import React, {useEffect, useRef, useState} from 'react';
import './CFAdminVinRefresh.scss';
import {Formik} from "formik";
import {FVPSelect} from "../../components/formField";
import CFAdminNotification from "../../components/CFAdminNotification";
import CFAdminConfirmDialog from "../../components/CFAdminConfirmDialog";
import VehicleConfigService from "../../services/VehicleConfigService";
import VinImportService from "../../services/VinImportService";

type OptionType = { description: string; code?: string };

function CFAdminVinRefresh() {
    const notificationRef = useRef<any>();
    const [yearOptions, setYearOptions] = useState<OptionType[]>([]);
    const [selectedYear, setSelectedYear] = useState('');
    const [decodeVin, setDecodeVin] = useState('');
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    const loadVehicleYears = () => {
        VinImportService.getVehicleAttributeValues({ attributeIds: [14] })
            .then(response => {
                const attributeValues = response.data?.attributeValues;
                if (attributeValues) {
                    const mappedYearOptions: OptionType[] = attributeValues
                        .filter((item: any) => item.attributeValueDescription != null)
                        .map((item: any) => ({
                        description: item.attributeValueDescription,
                        code: String(item.attributeValueId)
                    }));
                    setYearOptions(mappedYearOptions);
                }
            })
            .catch(e => {
                console.log(e);
            });
    };

    useEffect(() => {
        loadVehicleYears();
    }, []);

    const handleYearChange = (e: any) => {
        setSelectedYear(e.target.value);
    };

    const handleVinChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setDecodeVin(e.target.value);
    };

    const showSuccessMessage = (value: string) => {
        notificationRef.current.successMessage(value);
    };

    const showErrorMessage = (value: string) => {
        notificationRef.current.failureMessage(value);
    };

    const handleSubmit = () => {
        if (selectedYear === '' && decodeVin.trim() === '') {
            showErrorMessage("Please select Year or enter a Decode VIN.");
            return;
        }
        setIsConfirmOpen(true);
    };

    const handleConfirmSubmit = async () => {
        setIsConfirmOpen(false);
        try {
            const vinList = decodeVin
                .split(/[\n,]+/)
                .map((vin) => vin.trim())
                .filter((vin) => vin.length > 0);

            const requestBody: any = {
                vin: vinList
            };

            if (selectedYear !== '') {
                requestBody.modelYearId = Number(selectedYear);
            }
            await VehicleConfigService.vinRefresh(requestBody);
            showSuccessMessage("VIN Refreshed successfully.");
            resetForm();
        } catch (error) {
            console.error(error);
            showErrorMessage("Failed to refresh VIN. Please try again.");
        }
    };

    const handleConfirmClose = () => {
        setIsConfirmOpen(false);
    };

    const resetForm = () => {
        setSelectedYear('');
        setDecodeVin('');
    };

    return (
        <div className="config-component">
            <h2 className="fomo-type--title">
                Vin Refresh
            </h2>
            <Formik
                initialValues={{year: ''}}
                onSubmit={handleSubmit}
            >
                {() => (
                    <div className="fvp-form">
                        <div className="modal-top-div">
                            <div className="modal-body">
                                <div className="vin-refresh-content">
                                    <div className="ext1">
                                        Please select a Year <b>OR</b> enter a Decode VIN.
                                        <div className="container">
                                            <div className="box">
                                                <div className="box-row">
                                                    <div className="box-cell box2">
                                                        <div className="fvp-form__subgroup">
                                                            <FVPSelect
                                                                style={{width: "200px"}}
                                                                className="vin-refresh-year-field"
                                                                label="Year:"
                                                                name="year"
                                                                value={selectedYear}
                                                                data-testid="year"
                                                                onChange={handleYearChange}
                                                                options={yearOptions}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="box-cell box1">
                                                        <div className="fvp-form__subgroup vin-refresh-or-group">
                                                            <b className="vin-refresh-or-label">OR</b>
                                                        </div>
                                                    </div>
                                                    <div className="box-cell box1">
                                                        <div className="fvp-form__subgroup vin-refresh-textarea-group">
                                                            <label className="vin-refresh-textarea-label" htmlFor="vin-refresh-textarea">
                                                                Decode VIN:
                                                            </label>
                                                            <textarea
                                                                id="vin-refresh-textarea"
                                                                className="vin-refresh-textarea"
                                                                data-testid="vin"
                                                                placeholder={'Enter the VINs as comma-separated values, or place each VIN on a new line.'}
                                                                value={decodeVin}
                                                                onChange={handleVinChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer button-frame">
                                        <button data-testid="step-cancel"
                                                className="fvp-button--outline fvp-button"
                                                type="button"
                                                onClick={resetForm}>
                                            <i className="fvp-left-chevron"/>Cancel
                                        </button>
                                        <div className="right-align">
                                            <button data-testid="step-submit"
                                                    className="fvp-button button-right-align"
                                                    type="button"
                                                    onClick={handleSubmit}>
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Formik>
            <CFAdminConfirmDialog
                isOpen={isConfirmOpen}
                onClose={handleConfirmClose}
                onConfirm={handleConfirmSubmit}
                title="Confirm Submission!"
                text="Are you sure you want to submit the VinRefresh?"
            />
            <CFAdminNotification ref={notificationRef}/>
        </div>
    );
}

export default CFAdminVinRefresh;
